<template>
  <section>
    <v-btn flat icon>
      <v-icon small @click="dialog = true">mdi-pencil</v-icon>
    </v-btn>
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="headline green white--text darken-2" primary-title>
          Atualizar Porte do Estudo Ambiental
        </v-card-title>

        <v-card-text>

          <v-form v-model="valid">
            <v-text-field
              v-model="typologySize.min"
              :rules="requiredRules"
              label="Valor Mínimo"
              required></v-text-field>
            <v-text-field
              v-model="typologySize.max"
              :rules="requiredRules"
              label="Valor Máximo"
              required></v-text-field>
            <v-select
              v-model="typologySize.enviromental_study_type_id"
              :hint="'Selecione um Tipo de Estudo Ambiental'"
              :items="enviromentalStudyTypes"
              item-text="name"
              item-value="id"
              single-line
              label="Tipo de Estudo Ambiental"></v-select>
          </v-form>

        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="closeDialog()">Cancelar</v-btn>
          <v-btn color="primary" flat @click="update()">Atualizar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>

import EnviromentalStudyType from '@/services/applications/configurations/EnviromentalStudyTypeService';
import TypologySizeService from '@/services/applications/configurations/TypologySizeService';
import validationRules from '@/mixins/validation-rules';

export default {
  name: 'EditTypologySize',
  components: {},
  mixins: [validationRules],
  props: ['typology', 'typologySize'],
  mounted() {
    EnviromentalStudyType
      .fetchEnviromentalStudyTypes()
      .then((response) => {
        this.enviromentalStudyTypes = response.data;
      });
  },
  data() {
    return {
      requiredRules: [validationRules.required],
      dialog: false,
      valid: false,
      enviromentalStudyTypes: [],
    };
  },
  methods: {
    update() {
      const vm = this;

      TypologySizeService
        .updateTypologySize(vm.typology.id, vm.typologySize)
        .then(() => {
          vm.$swal({
            title: 'Estudo Ambiental atualizado com Sucesso',
            text: '',
            type: 'success',
            confirmButtonText: 'Ok',
          }).then(() => {
            vm.typology.typology_sizes.forEach((item, index) => {
              if (item.id === vm.typologySize.id) {
                Object.assign(vm.typology.typology_sizes[index], vm.typologySize);
              }
            });
            vm.dialog = false;
          });
        })
        .catch((error) => {
          vm.$swal({
            title: 'Erro',
            text: error.response.data.join('\n'),
            type: 'error',
            showConfirmButton: 'Ok',
          });
        });
    },
    closeDialog() {
      this.dialog = false;
    },
  },
};
</script>

<style scoped lang="scss">
</style>
